export default __webpack_public_path__ + "static/media/ally_m1.0a5c6340.png";